import volumeImg from '@/assets/images/volume-up.svg';
import volumeOffImg from '@/assets/images/volumeMute.svg';

// 音量ボタンのクリックイベントを設定する関数
export const volumeButtonClickAction = () => {
  const volumeIcon = window.storeeelItems.isMobile
    ? document.querySelector('.storeeel-menu-area-icons img[alt="volume"]')
    : document.querySelector('#volume-desktop') ;
  volumeIcon.addEventListener('click', () => {
    // activeなスライドの音量変更
    const activeVideo = document.querySelector(
      '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video'
    );
    if (!activeVideo) return;
    if (activeVideo instanceof HTMLVideoElement) {
      if (activeVideo.muted) {
        activeVideo.muted = false;
        volumeIcon.src = volumeImg;
        volumeIcon.setAttribute("data-muted", "false");
      } else {
        activeVideo.muted = true;
        volumeIcon.src = volumeOffImg;
        volumeIcon.setAttribute("data-muted", "true");
      }
    }
  });
}
